import React from "react"
import classNames from "classnames"
import "@fontsource-variable/inter";

import "../../assets/styles/common.scss"
import componentStyles from "./Layout.module.scss"
import Header from "../Sections/Header/Header"
import { useIntl } from "gatsby-plugin-intl"
import Footer from "../Sections/Footer/Footer"
import ContactUs from "../UI/ContactUs/ContactUs";
import ScrollToTopButton from "../UI/ScrollToTopButton/ScrollToTopButton";

export interface LayoutProps {
	location: {
		pathname: string
	}
	children: any
	className?: string
}

const Layout: React.FC<LayoutProps> = ({ children, className, location }) => {
	const pathname = location?.pathname ?? ""
	const intl = useIntl()
	const isHome = pathname === `/${intl.locale}/`

	const layoutClasses = classNames(componentStyles.layout, className)

	return (
		<div className={layoutClasses}>
			<Header isHome={isHome} location={location} />
			<main>
				{children}
				<ContactUs />
			</main>
			<ScrollToTopButton />
			<Footer pathname={pathname} />
		</div>
	)
}

export default Layout
